import promoSubscriptionTags from '@/shared/assets/videos/promo_sub.png'
import { cn } from '@/shared/lib'
import { typographyStyle } from '@/shared/lib/catalog'
import { designTokens } from '@/shared/lib/design-tokens'

const promoTokens = designTokens.components.videoSubscriptionPromo

const titleStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.inverse,
  ...typographyStyle(designTokens.typography.body.lg, {
    fontSize: '18px',
    lineHeight: 'normal',
    fontWeight: 600,
  }),
}

const bodyStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.inverse,
  ...typographyStyle(designTokens.typography.body.md, {
    lineHeight: 'normal',
  }),
}

const ctaStyle = {
  width: promoTokens.ctaWidth,
  height: promoTokens.ctaHeight,
  borderRadius: promoTokens.ctaRadius,
  border: 'none',
  backgroundColor: promoTokens.ctaBackground,
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.inverse,
  ...typographyStyle(designTokens.typography.body.xsSemibold),
  cursor: 'pointer',
}

type VideoSubscriptionUpsellProps = {
  className?: string
  ctaLabel?: string
  onCtaClick?: () => void
}

export function VideoSubscriptionUpsell({
  className,
  ctaLabel = 'Оформить подписку',
  onCtaClick,
}: VideoSubscriptionUpsellProps) {
  return (
    <section
      className={cn('mx-auto flex w-full flex-col', className)}
      style={{
        maxWidth: promoTokens.width,
        padding: promoTokens.padding,
        gap: promoTokens.gap,
        borderRadius: promoTokens.radius,
        background: promoTokens.background,
        boxShadow: promoTokens.shadow,
      }}
    >
      <div className="flex w-full flex-col gap-6 xl:flex-row xl:items-start xl:justify-between">
        <div
          className="flex w-full flex-col gap-3"
          style={{
            maxWidth: promoTokens.headlineWidth,
            transform: `translate(${promoTokens.headlineOffsetX}, ${promoTokens.headlineOffsetY})`,
          }}
        >
          <h3 style={titleStyle}>Больше материалов доступно в подписке</h3>
          <p style={bodyStyle}>
            Чтобы начать изучение материала и получить доступ ко множеству других, вам нужно
            оформить доступ к epic growth community.
          </p>
          <button type="button" style={ctaStyle} onClick={onCtaClick}>
            {ctaLabel}
          </button>
        </div>
        <img
          src={promoSubscriptionTags}
          alt=""
          aria-hidden="true"
          className="w-full max-w-full xl:w-auto"
          style={{
            maxWidth: promoTokens.chipsWidth,
            transform: `translate(${promoTokens.chipsOffsetX}, ${promoTokens.chipsOffsetY})`,
          }}
        />
      </div>
    </section>
  )
}

VideoSubscriptionUpsell.displayName = 'VideoSubscriptionUpsell'
